import React from "react";
import MuiTextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Icon from "../Icon/Icon";
import IconButton from "../IconButton/IconButton";
import styles from "./IconTextField.module.scss";

const renderStartAdornment = ({
  startIconName,
  startSelectValue,
  startSelectOptions,
  onStartSelectChange,
  startSelectDisabled,
  startSelectAriaLabel,
  onBlur,
}) => {
  if (typeof onStartSelectChange === "function") {
    return (
      <InputAdornment position="start" className={styles.startSelectAdornment}>
        <Select
          value={startSelectValue || ""}
          onChange={(event) => onStartSelectChange(event.target.value)}
          onBlur={onBlur}
          disabled={startSelectDisabled}
          variant="standard"
          disableUnderline
          displayEmpty
          aria-label={startSelectAriaLabel}
          className={styles.startSelect}
          MenuProps={{
            PaperProps: {
              className: styles.startSelectMenu,
            },
          }}
          renderValue={(selected) => {
            if (!selected) {
              return "—";
            }

            const option = (startSelectOptions || []).find(
              (item) => item.value === selected
            );
            return option?.label || selected;
          }}
        >
          {(startSelectOptions || []).map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        <span className={styles.divider} aria-hidden="true" />
      </InputAdornment>
    );
  }

  if (startIconName) {
    return (
      <InputAdornment position="start">
        <Icon name={startIconName} fontSize="small" />
      </InputAdornment>
    );
  }

  return undefined;
};

const IconTextField = ({
  id,
  name,
  label,
  type,
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  startIconName,
  endIconName,
  endIconAriaLabel,
  onEndIconClick,
  startSelectValue,
  startSelectOptions,
  onStartSelectChange,
  startSelectDisabled = false,
  startSelectAriaLabel,
  ...rest
}) => (
  <MuiTextField
    id={id}
    name={name}
    label={label}
    type={type}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    onBlur={onBlur}
    error={error}
    helperText={helperText}
    InputProps={{
      startAdornment: renderStartAdornment({
        startIconName,
        startSelectValue,
        startSelectOptions,
        onStartSelectChange,
        startSelectDisabled,
        startSelectAriaLabel,
        onBlur,
      }),
      endAdornment:
        endIconName && endIconAriaLabel ? (
          <InputAdornment position="end">
            <IconButton
              type="button"
              iconName={endIconName}
              ariaLabel={endIconAriaLabel}
              onClick={onEndIconClick}
            />
          </InputAdornment>
        ) : undefined,
    }}
    {...rest}
  />
);

export default IconTextField;
